import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/index'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers:[AuthService]
})
export class SidebarComponent implements OnInit {
  _postsArray:any[];
  selectedItem:any;
  constructor(private Auth: AuthService) { }

  ngOnInit(): void {
    this.getSidebar();
  }
  getSidebar() {
    this.Auth.modulesList()
    .subscribe(
     resultArray =>
     { 
       //this._postsArray = resultArray;
      this.formatmenudata(resultArray);
   // console.log('menus',JSON.stringify(resultArray));
    }
,
     error => console.log("Error :: " + error)
 )
}


formatmenudata(resarr)
{
  debugger
 console.log('multiarray-arr',resarr);
  var arr = [];
    var issued = [];
    var returned = [];
    var lvalue='';
    for ( var i = 0; i < resarr.length ; i++) {
      //console.log('multiarray '+i,JSON.stringify(resarr[i].mnlbl.length));
       
         
         
if(resarr[i].mnlbl==lvalue)
{
  resarr[i].mnlbl='';
}

         

          if (resarr[i].mnlbl.length>0)  
          {
            lvalue=resarr[i].mnlbl;

          }
           // arr.push(resarr[i].date15);
            //issued.push(parseInt( resultArray[i].issued)); // 
           // returned.push(parseInt( resultArray[i].returned));
           returned.push(resarr[i]); 
          // this._postsArray=  returned   
           
    }


   // console.log('arrreturned',JSON.stringify(returned));
    this._postsArray=  returned  ;
}

menutoggle(e,indexi)
{
  //console.log(e.currentTarget.id);
  if(this.selectedItem == indexi)
  {
    this.selectedItem=-1;
   
  }
  else
  {
    debugger
  this.selectedItem = indexi;
  // console.log("Child:", e.target);
  // console.log("Parent:", e.target.parentNode); 
  // console.log("Parents parent sibling:", e.target.parentNode.parentNode.nextSibling);
  }
    //newValue.showSubfolders = !newValue.showSubfolders
    e.stopPropagation()
}

 
}